import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { AcknowledgeDialogSettings } from './acknowledge-dialog-settings';
import { NgIf } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-acknowledge-dialog',
    templateUrl: './acknowledge-dialog.component.html',
    styleUrls: ['./acknowledge-dialog.component.scss'],
    imports: [NgIf, MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class AcknowledgeDialogComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<AcknowledgeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AcknowledgeDialogSettings) { }

  ngOnInit(): void {
  }

}
